import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/Manual_Recording/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import RecTable from 'components/Web_User_Interface/1440p_Series/Features/Manual_Recording/recTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü // Manuelle Aufnahme",
  "path": "/Web_User_Interface/1440p_Serie/Features/Manuelle_Aufnahme/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Definieren Sie hier die Gesamtdauer und Auflösung für manuelle Aufnahmen, die Sie über die Schnellleiste initiieren können. Beachten Sie, dass die eingestellte Vorlaufzeit in die Gesamtdauer der Aufnahme integriert ist.",
  "image": "./WebUI_1440p_SearchThumb_Features_FTP.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_FTP.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Features Menü // Manuelle Aufnahme' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Definieren Sie hier die Gesamtdauer und Auflösung für manuelle Aufnahmen, die Sie über die Schnellleiste initiieren können. Beachten Sie, dass die eingestellte Vorlaufzeit in die Gesamtdauer der Aufnahme integriert ist.' image='/images/Search/WebUI_1440p_SearchThumb_Features_FTP.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_FTP.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/Manual_Recording/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/Manual_Recording/' crumbLabel="Manuelle Aufnahme" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/2e367/1440p_Settings_Features_Manual_Rec.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.39130434782609%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACD0lEQVQoz3WQS2sTYRSG8z+6qdKkuVcUpM1kLl8m33SSJpOZ3CZJk6ZVtFJN0Uq1VksVpKC4EjcKLhRKV7YVqqticeOiiOAv8Kc8MqmloLh4OO/i8PCeE0qn0ySTSZKpFNGxc2jt+zS2Dik93MXZ+EhhfR9rbY/pPwTZXtul8+wLevcRmjJJKj3ByMgIo6OjhOLxOAGJRILw2HlyJZ/+yhadW5vMDp78h8f0bj/Fri2QmVSYmlK5dPHykFAgOiUciWCoCh2/il938WsVWg2XulfGLdm45QJuqYAX5KLEKc2gaxZqVmDoebKKcdYwIBwOYxiCTmcW329RbzTxqjXKjkOxaGNLE2lJhG2TKznUGvPYpoOhCzQ1RyajEYrFYsN2p0IhBN1ul1arRbPZxPOq1DvztBeWaC+uMte/wd16neVWj4XGLN2qg5QGumqiZPQT4WnDSCSCqqq4rkvFqeC5LrWah1cpU72yirfykrm5OzyXFptCMuh5DK5LbEsfnq0qfwlPcoyJiQvkDIk087T9AsWCiS0FRnYKU2jMlCzWNx6wv/2KQd9E6BoyJ9BV9ezkYAaMj4+TiCeHPwmwbYnMGwhDcLXXZPnmEu/fveXnj2/8Ojrk9coiupbBMgXZrPpvw2g0SiKRGsp0TWDmJKbIca3fZefNC/YOPvH9+CtHH7Y5/nzAzuY9qtPqcDeraPwGdRRXjNWgnMQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/6e24afb507e6a8b6cc80e5be01407ab4/e4706/1440p_Settings_Features_Manual_Rec.avif 230w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/d1af7/1440p_Settings_Features_Manual_Rec.avif 460w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/7f308/1440p_Settings_Features_Manual_Rec.avif 920w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/730d0/1440p_Settings_Features_Manual_Rec.avif 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/6e24afb507e6a8b6cc80e5be01407ab4/a0b58/1440p_Settings_Features_Manual_Rec.webp 230w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/bc10c/1440p_Settings_Features_Manual_Rec.webp 460w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/966d8/1440p_Settings_Features_Manual_Rec.webp 920w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/fbb05/1440p_Settings_Features_Manual_Rec.webp 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/6e24afb507e6a8b6cc80e5be01407ab4/81c8e/1440p_Settings_Features_Manual_Rec.png 230w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/08a84/1440p_Settings_Features_Manual_Rec.png 460w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/c0255/1440p_Settings_Features_Manual_Rec.png 920w", "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/2e367/1440p_Settings_Features_Manual_Rec.png 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/6e24afb507e6a8b6cc80e5be01407ab4/c0255/1440p_Settings_Features_Manual_Rec.png",
              "alt": "Web User Interface - 1440p Series - Features Manuelle Aufnahme",
              "title": "Web User Interface - 1440p Series - Features Manuelle Aufnahme",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <RecTable mdxType="RecTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      